import type { ReactNode } from "react";
import { Combobox as HeadlessUICombobox } from "@headlessui/react";
import classNames from "classnames";

export interface ComboboxComponentProps<T = unknown> {
  children: ReactNode;
  value?: T | null;
  onChange: (value: T) => void;
  className?: string;
}

export const ComboboxComponent = <T,>({
  children,
  value,
  onChange,
  className,
  ...rest
}: ComboboxComponentProps<T>) => (
  <div className={classNames("relative", className)}>
    <HeadlessUICombobox value={value} onChange={onChange} {...rest}>
      {children}
    </HeadlessUICombobox>
  </div>
);
